import { of, Subject } from 'rxjs';
import { CacheChainOption } from '../interfaces/cache-chain.interface';
import { CoreOptions } from '../interfaces/core-options.interface';
import { StorageAdapter } from '../interfaces/storage-adapter.interface';

export interface CoreProtocol {
    options: CoreOptions;
    store?: any;
    state?: any;
    storage: StorageAdapter;
    events?: { [key: string]: Subject<any> };
    chaining: { [key in CacheChainOption]?: string | boolean };
}

export const Core: CoreProtocol = {
    options: {
        silent: true,
    },
    state: {
        enabled: false,
        getState: () => {},
        sync: () => {},
        getState$: of(),
    },
    store: {},
    storage: {
        enabled: false,
        get: (key) => Promise.resolve(),
        set: (key, val) => Promise.resolve(),
        clear: () => Promise.resolve(),
    } as StorageAdapter,
    events: {},
    chaining: {},
};
